import { Outlet } from '@remix-run/react';
import { motion } from 'framer-motion';
import { ClientOnly } from 'remix-utils/client-only';

import { RaffleAppLogoDark } from '~/components/RaffleLogo';
import { blurIn } from '~/utils';

import { GradientCanvas } from './GradientCanvas';
import { Logos } from './Logos';

export const Layout = () => (
  <div className="bg-primary-600 relative flex h-full w-full items-center justify-center overflow-hidden">
    <ClientOnly>{() => <GradientCanvas />}</ClientOnly>
    <motion.div
      initial={{ opacity: 0, filter: 'blur(5px)' }}
      animate={{ opacity: 1, filter: 'blur(0px)' }}
      className="z-50 flex h-3/5 w-full flex-col justify-start px-8 py-12 md:w-[500px] md:p-12"
    >
      <div className="relative flex w-full flex-col items-center justify-center gap-10">
        <RaffleAppLogoDark className="h-18 w-18 shadow-2xl shadow-black" />
        <Outlet />
      </div>
    </motion.div>
    <motion.div
      {...blurIn}
      className="absolute right-0 bottom-2 left-0 lg:bottom-6"
    >
      <Logos />
    </motion.div>
  </div>
);
